import {  Box, Card, CardActions, CardContent, ListItem, ListItemButton, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import styles from './AppItem.module.css';
import { mainUrl, staticUrl } from "services/data/mainUrl";
import itemBg2 from "assets/images/item-background.png";
import { forwardRef } from "react";

const AppItem = forwardRef(({ selected, id, name, package: packageName, version, build, onSelect,
                    minSdk, targetSdk, abi, support, signedFor, icon, profile}, ref) => {                     

    return (
        <ListItemButton
            ref={ref}
            sx={{
                pr:1, pb: 1, pl:0, pt: 0, flexGrow: 1,               
                '& :hover.MuiPaper-root':{
                    backgroundColor: 'rgb(248, 248, 238) !important'
                },
                '&.Mui-selected .MuiCard-root': {
                    backgroundImage: 'unset',
                    backgroundColor: 'aliceblue'
                }
            }}
            selected={selected}
        >
            <Card 
                sx={{width:'100%'}} 
                onClick={(e) => onSelect({id, name, packageName})}
            >
                <CardContent sx={{padding: '0px 0px 0px 8px !important'}}>
                    <Box 
                        sx={{display: 'flex', alignItems: 'stretch', justifyContent: 'flex-start'}}>
                        <img className={styles.appicon}
                            src={`${staticUrl}${icon}`}
                            alt="App Icon"/>
                        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', minWidth: 0, overflow: 'hidden'}}>
                            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'stretch', width: '100%', overflow: 'hidden', minWidth: 0}}>
                                <Typography className={styles.name}>{name}</Typography>
                                <Typography className={styles.packageName} variant="caption">{packageName}</Typography>
                            </Box>
                            <Box sx={{display: 'flex', flexDirection: 'column'}}>
                                
                            </Box>
                        </Box>
                        <div className={styles.versionWrapper}>
                            <div className={styles.version}>Версия <span>{version}</span></div>
                            <div className={styles.build}>Сборка <span>{build}</span></div>    
                        </div>
                    </Box>
                </CardContent>                
            </Card>
        </ListItemButton>
    );
});

export default AppItem;